<template>
  <ion-page>
    <TheHeaderMenu name="TheHeaderMenu" />
    <ion-content>
      <ion-refresher slot="fixed" @ionRefresh="handleRefresh($event)">
        <ion-refresher-content
          :pulling-icon="chevronDownCircleOutline"
          pulling-text="Pull to refresh"
          refreshing-spinner="circles"
          refreshing-text="Refreshing..."
        >
        </ion-refresher-content>
      </ion-refresher>
      <!--<PopularCarousel name="PopularCarousel" :coffeeShops="coffeeShops" />
      <PromoCarousel name="PromoCarousel" />
      <PreviousCarousel name="PreviousCarousel" :coffeeShops="coffeeShops" />
      <hr class="solid" />
      <FavoritesCarousel name="FavoritesCarousel" :coffeeShops="coffeeShops" />
      <hr class="solid" />-->
      <HomeCafeTabs
        name="HomeCafeTabs"
        :coffeeShops="coffeeShops"
        :faveCoffeeShops="faveCoffeeShops"
      />
    </ion-content>
    <TheFooter name="TheFooter" />
  </ion-page>
</template>

<script>
import { defineComponent } from "vue";
import {
  IonPage,
  IonContent,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonHeader,
  IonItem,
  IonButtons,
  IonMenuButton,
  IonList,
  IonIcon,
  IonToolbar,
  IonMenu,
  IonRefresher,
  IonRefresherContent,
} from "@ionic/vue";
import { chevronDownCircleOutline } from "ionicons/icons";
import axios from "axios";

import TheHeaderMenu from "@/components/TheHeaderMenu.vue";
import HomeCafeTabs from "@/components/HomeCafeTabs.vue";
import TheFooter from "@/components/TheFooter.vue";

const BASE_URI =
  process.env.VUE_APP_BASE_URI !== undefined
    ? process.env.VUE_APP_BASE_URI
    : "https://api.onecoffeeapp.com.au";

export default defineComponent({
  name: "MainLayout",
  components: {
    TheHeaderMenu,
    TheFooter,
    HomeCafeTabs,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardSubtitle,
    IonCardTitle,
    IonPage,
    IonContent,
    IonHeader,
    IonItem,
    IonButtons,
    IonMenuButton,
    IonList,
    IonIcon,
    IonToolbar,
    IonMenu,
    IonRefresher,
    IonRefresherContent,
  },
  data() {
    return {
      coffeeShops: [],
      faveCoffeeShops: [],
      chevronDownCircleOutline,
    };
  },
  methods: {
    async handleRefresh(event) {
      await this.getCoffeeShops();
      // Complete the refresh animation
      event.target.complete();
    },
    generatePlaceholderRatings(shops) {
      for (let i = 0; i < shops.length; i++) {
        shops[i].averageRatings = (Math.random() * (5.0 - 4.9) + 4.9).toFixed(
          2
        );
      }
    },
    async getCoffeeShops() {
      if (process.env.NODE_ENV === "development") {
        console.log("[HomeLayout] getCoffeeShops() called");
      }
      try {
        // Check if user is logged in
        const token = localStorage.getItem("token");
        const isLoggedIn = token !== null && token !== "null" && token !== "";

        let paramsData = {
          isDeleted: "0",
        };

        let axiosConfig = {
          headers: {
            Authorization: token,
            "Content-Type": "application/json;charset=UTF-8",
          },
          params: paramsData,
        };

        // Fetch coffee shops
        let result = await axios.get(
          BASE_URI + "/cafe/get-coffee-shops",
          axiosConfig
        );

        this.coffeeShops =
          result && result.data && result.data.data && result.data.data.length
            ? result.data.data
            : [];

        // TODO: Replace with real rating data from API - currently using placeholder test data
        this.generatePlaceholderRatings(this.coffeeShops);

        // Only fetch favorites if user is logged in
        if (isLoggedIn) {
          // Validate user ID from localStorage
          const rawId = localStorage.getItem("id");
          const isValidId = rawId !== null && rawId !== "" && rawId !== "null";

          if (isValidId) {
            let faveParamsData = {
              userId: rawId,
            };

            let axiosConfigFaveCafe = {
              headers: {
                Authorization: token,
                "Content-Type": "application/json;charset=UTF-8",
              },
              params: faveParamsData,
            };

            let favoriteCafes = await axios.get(
              BASE_URI + "/favorites/get-favorites",
              axiosConfigFaveCafe
            );

            this.faveCoffeeShops =
              favoriteCafes &&
              favoriteCafes.data &&
              favoriteCafes.data.data &&
              favoriteCafes.data.data.length
                ? favoriteCafes.data.data
                : [];
          } else {
            // Invalid user ID, skip favorites fetch
            console.warn(
              "[HomeLayout] Invalid user ID in localStorage, skipping favorites"
            );
            this.faveCoffeeShops = [];
          }
        } else {
          // User not logged in, set favorites to empty array
          this.faveCoffeeShops = [];
        }
      } catch (error) {
        console.error("[HomeLayout] Error fetching data:", error);
        this.coffeeShops = [];
        this.faveCoffeeShops = [];
      }
    },
  },
  async created() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    if (queryString !== null) {
      if (localStorage.getItem("token") === null) {
        localStorage.setItem("token", urlParams.get("token"));
        localStorage.setItem("id", urlParams.get("id"));
        localStorage.setItem("name", urlParams.get("name"));
        localStorage.setItem("email", urlParams.get("email"));
        localStorage.setItem("mobile", urlParams.get("mobile"));
        localStorage.setItem("userType", urlParams.get("userType"));
        localStorage.setItem("cafeId", urlParams.get("cafeId"));
      }

      this.$router.push("/home");
    }

    await this.getCoffeeShops();
  },
});
</script>
<style scoped>
hr.solid {
  border-top: 1px solid #f3f3f3;
  margin-bottom: 10px;
}
ion-content {
  --overflow: hidden;
}
ion-content::part(scroll) {
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
